// src/App.js
import React from "react";
import AppRoutes from "./app/routing/AppRoutes";
import { AuthProvider } from "./app/auth/core/AuthContext";
import Version from "./_ekdizayn/layout/version/Version";
import ArchiveBanner from "./app/archive/ArchiveBanner";
import ArchiveRouteGuard from "./app/archive/ArchiveRouteGuard";
import ArchiveActionGate from "./app/archive/ArchiveActionGate";


function App() {
  
  return (
    <AuthProvider>
      <ArchiveBanner />
      <ArchiveRouteGuard />
      <ArchiveActionGate />
      <AppRoutes />
      <Version/>
    </AuthProvider>
  );
}

export default App;
